<template>
    <div class="row box-item-valoracion py-2 align-items-center">
        <div class="col-lg-5 col-md-6 col-12">
            <div class="row">
                <div class="col-md-4 col-6 text-left">
                    <img v-if="pedido.articulo" class="variedad-img" :src="pedido.articulo.img_verify" alt="Imagen variedad">
                    <img v-else class="variedad-img" :src="pedido.variety.imagen" alt="Imagen variedad">
                </div>
                <div class="col-md-8 col-6 text-left">
                    <div>
                        Nº Pedido <span class="font-weight-bold">{{ pedido.pedido.numero_pedido}}</span>
                    </div>
                    <div>
                        Fecha de entrega<br/>
                        <span class="font-weight-bold">{{ pedido.fecha_entrega }}</span>
                    </div>
                    <div v-if="pedido.articulo" class="font-weight-bold" style="letter-spacing: -0.5px">
                        {{ pedido.articulo.nombre_verify}}<br/>
                        {{ pedido.articulo.mote_verify ? pedido.articulo.mote_verify.nombre : ''}}<br/>
                        {{ pedido.articulo.especie_verify  ? pedido.articulo.especie_verify.nombre : '' }}
                    </div>
                    <div v-else class="font-weight-bold" style="letter-spacing: -0.5px">
                        {{ pedido.subprograma.articulo.nombre_verify}}<br/>
                        {{ pedido.subprograma.articulo.mote_verify ? pedido.subprograma.articulo.mote_verify.nombre : ''}}<br/>
                        {{ pedido.subprograma.articulo.especie_verify  ? pedido.subprograma.articulo.especie_verify.nombre : '' }}
                    </div>
                </div>
                <div class="col-12 mt-2">
                    <div>
                        <div class="text-left font-weight-bold">Valora esta variedad</div>
                        <div>
                            <star-rating :star-size="starSizeNumber" v-model="rating" :show-rating="false" v-bind:min-rating="0" class="estrellas justify-content-left justify-content-lg-left"></star-rating>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-7 col-md-6 col-12 mt-3">
            <div class=" text-left font-weight-bold">¿Quieres compartir tu opinión con otros?</div>
            <textarea name="share-valoracion" v-model="comentario" class="form-control"></textarea>
            <div class=" text-left font-weight-bold mt-2">¿Quieres compartir una foto de tu cultivo?</div>
            <b-form-file v-model="image" accept=".jpg, .jpeg" placeholder="Elige una imagen o arrastrala aquí..." browse-text="Buscar" style="overflow: hidden"></b-form-file>
            <p>
                Al enviar el formulario aceptas los
                <a class="form-terminos" :href="route('info.terminos.condiciones')">términos y condiciones</a>
                y la <a class="form-terminos" :href="route('info.politica.privacidad')">política de privacidad</a>.
            </p>
            <div class="row">
                <div class="col-lg-7 col-md-12">
                    <b-form-checkbox value="1" unchecked-value="0" v-model="mostrarNombre">
                        Mostrar mi nombre en la valoración
                    </b-form-checkbox>
                </div>
                <div class="col-lg-5 col-md-12">
                    <div class="btn d-block text-center py-2 btn-enviar-opinion" @click="submitValoracion">
                        ENVIAR
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import StarRating from 'vue-star-rating';

    export default {
        name: "EncuestaVariedadComponent",
        props: ['pedido'],
        components: {
            StarRating
        },
        data: function () {
            return{
                starSizeNumber: 30,
                comentario: '',
                mostrarNombre: '',
                rating: 3,
                submitting: false,
                image: null
            }
        },
        methods: {
            submitValoracion: function () {
                var pedido = this.pedido;

                if(this.submitting){
                    return;
                }

                if (this.image) {
                    if (this.image.size / 1024 > 2048) {
                        Vue.toasted.show('La imagen debe ser menor a 2 MB', {
                            type: "warning",
                            duration: 3000
                        });
                        return;
                    }
                }

                this.submitting = true;

                let formData = new FormData();
                formData.append('id', pedido.id);
                formData.append('show_name', this.mostrarNombre);
                formData.append('rating', this.rating);
                formData.append('comment', this.comentario);
                if (this.image) {
                    formData.append('image', this.image);
                }
                formData.append('custom_type', pedido.variety ? 1 : 0);

                axios.post(this.route("account.valoraciones.variedad.store"), formData).then((res) => {

                    Vue.toasted.show('Encuesta recibida', {
                        type: "success",
                        duration: 3000
                    });

                    this.$emit('voted', this.pedido);
                }).catch((err) => {

                    if(err.response.status == 422){
                        Vue.toasted.show('Error interno de la plataforma', {
                            type: "error",
                            duration: 3000
                        });
                    }else{
                        Vue.toasted.show('Error al intentar guardar la encuesta. Inténtalo más tarde.', {
                            type: "error",
                            duration: 3000
                        });
                    }

                }).finally(() => {
                    this.submitting = false;
                });
            }
        }
    }
</script>

<style scoped>

    .box-item-valoracion{
        border-top: 1px solid grey;
    }

    .form-terminos {
        text-decoration: underline;
        color: #000000;
    }

    .variedad-img {
        max-width: 100%;
        width: 100%;
        height: auto;
    }

    .btn-enviar-opinion {
        font-size: 17px;
        width: 100%;
        font-weight: bold;
        padding: 5px;
        margin-top: 10px;
        color: #ffffff;
        background-color: #ff3366;
        border-color: #db2d49;
        border-width: 2px;
        border-radius: 0;
        margin-bottom: 0.5em;
    }

    .btn-enviar-opinion:hover {
        background-color: #db2d49;
    }

</style>
